<template>
 <v-flex class="tree-item-node">
    <v-layout column>
        <v-flex class="tree-item-container">
            <v-layout row>
                <div class="align-center d-flex ml-1 mr-1 tree-item-arrow-container">
                    <v-icon v-if="hasChildren" :class="branchIcon" @click="toggleBranch"></v-icon>                               
                </div>                
                <div class="d-flex align-center tree-item-label-container" @click="selectCurrentItem">
                    <div v-if="this.item.itemType" class="tree-item-icon"  :style="`background-color:${iconColor}; color:${iconTextColor};`"><i :class="itemTypes[this.item.itemType].icon"></i></div>                
                    <label class="tree-item-label" :style="itemIsSelected ? `color:${secondaryColor}` : ''" >{{ item.name }}</label>                                                      
                </div>
            </v-layout>     
        </v-flex>
    </v-layout>
    <transition mode="out-in" name="slider" enter-active-class="fadeIn custom-speed" leave-active-class="fadeOut custom-speed">
        <v-layout column v-show="open" v-if="hasChildren" class="animated tree-item-children-container">
            <workflow-tree-item                         
                v-for="(node, index) in item.children"
                :key="index"
                :item="node"
                @branchOpened="branchOpened"  
                @branchClosed="branchClosed"
                @itemSelected="itemSelected"                     
                :currentSelectedItem="currentSelectedItem">
            </workflow-tree-item>                
        </v-layout>            
    </transition>    
  </v-flex>
</template>
<script>
  import ColorMixin from '../../plugins/mixins/ColorMixin'
  export default { 
    props: ['item', 'currentSelectedItem'],
    name: 'workflow-tree-item', 
    mixins:[ColorMixin],
    data() {
      return {                    
         open: false,
         itemTypes:{
                "root_event": {
                    label: "event",
                    color: "primaryColor",
                    text_color:"white",
                    icon:  "far fa-bell"                            
                },
                "done_event":{
                    label: "uitgevoerd event",
                    color: "successColor",
                    text_color:"white",
                    icon:  "fas fa-check"                                        
                },        
                "new_done_event": {
                    label: "+",
                    color: "grey",
                    text_color:"black",
                    icon:  "fas fa-check"            
                },
                "cancel_event":{
                    label: "anuleer event",
                    color: "errorColor",
                    text_color:"white",
                    icon:  "fas fa-ban"            
                }, 
                "new_cancel_event":{
                    label: "+",
                    color: "grey",
                    text_color:"black",
                    icon:  "fas fa-ban"                       
                },                
                "action": {
                    label: "aktie",
                    color: "infoColor",       
                    text_color:"white",
                    icon:  "fas fa-wrench"     
                },
                "new_action": {
                    label: "nieuwe actie",
                    color: "grey",     
                    text_color: "black",     
                    icon:  "fas fa-wrench"                  
                }    
           }          
      }
    },    
    computed: {
        hasChildren() {                        
            return (this.item.children) ? true : false
        },
        itemIsSelected(){
            return (this.currentSelectedItem && this.currentSelectedItem.id == this.item.id) ? true : false
        },
        iconColor(){            
            return this[this.itemTypes[this.item.itemType].color]
        },
        iconTextColor(){ 
            return this.itemTypes[this.item.itemType].text_color
        },
        branchIcon(){
            return this.open ? "fas fa-angle-down fa-lg" : "fas fa-angle-right fa-lg"
        } 
    },
    methods: {
        selectCurrentItem(){            
            // dont fire selected if current tree item is clicked
            if(!this.currentSelectedItem || (this.currentSelectedItem.id != this.item.id)){
                this.itemSelected( this.item )                     
            }
        },
        toggleBranch() {
            this.open = !this.open                
            
            if(this.open){
                this.branchOpened(this.item)
            }
            else{
                this.branchClosed(this.item)
            }
        },        
        branchOpened(e){
            this.$emit('branchOpened', e)
        },
        branchClosed(e){
            this.$emit('branchClosed', e)
        },
        itemSelected(e){                
            this.$emit('itemSelected', e)
        }
    },    
    mounted(){        
    }
  }
</script>

<style scoped>
.custom-speed {
    animation-duration: 300ms;
}   
.tree-item-container{
    margin-bottom:4px;
}
.tree-item-label-container{
    cursor:pointer;
}
.tree-item-arrow-container{
    width:14px;
}
.tree-item-children-container{
    margin-left:24px;
}

.tree-item-node {
  cursor: pointer;

}
.tree-item-icon{
    border-radius: 50%;
    width:24px;
    height:24px;
    text-align: center;    
    padding-top:2px;  
}
.tree-item-icon i{
    
}
.tree-item-label{
    padding-left:8px;   
    cursor:pointer;     

}
.bold {
  font-weight: bold;
}
.active{
    background-color: gray;
}
ul {
  list-style-type: none;
  padding-left: 1em;
  line-height: 1.5em;
  
}
</style>
